import { createApp } from 'vue';
import App from './App.vue'
import router from './router'
// 引入第三方组件库
import '@/assets/sass/common.scss'
// 引入Vue国际化翻译
import i18n from '@/i18n/i18n'

const app = createApp(App);
app.use(router);
app.use(i18n);
app.mount('#app');
